import { gql } from "@apollo/client";

export const GET_DMA_AVAILABILITY = gql`
  query GetDmaAvailability {
    getDmaAvailability {
      _id
      codes
      updatedAt
    }
  }
`;

export const UPDATE_DMA_AVAILABILITY = gql`
  mutation UpdateDmaAvailability($codes: [String!]!) {
    updateDmaAvailability(codes: $codes) {
      _id
      codes
      updatedAt
    }
  }
`;
